import { toast } from "sonner";
import { X, Mail, Copy } from "lucide-react";
import { SUPPORT_EMAIL } from "../lib/infoContent";

export const ContactModal = ({ open, onClose }) => {
  if (!open) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(SUPPORT_EMAIL); toast.success("Email copied"); }
    catch { toast.error("Could not copy"); }
  };
  return (
    <div className="fixed inset-0 z-[120] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="contact-modal">
      <div className="bg-white rounded-3xl w-full max-w-md p-7 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 rounded-2xl bg-[#FBF7EA] border border-[#D4AF37]/30 text-[#B8901F] flex items-center justify-center"><Mail size={20} /></span>
            <p className="font-display text-xl font-extrabold text-[#0F0F0F]">Contact LaunchBS</p>
          </div>
          <button onClick={onClose} className="text-[#687280] hover:text-[#0F0F0F]" data-testid="contact-close-x"><X size={20} /></button>
        </div>
        <p className="text-sm text-[#687280] mt-4">Need help or have a question?</p>
        <div className="mt-4 rounded-2xl border border-gray-200 bg-gray-50 px-4 py-3">
          <p className="text-[11px] font-bold uppercase tracking-widest text-[#9aa1ab]">Email</p>
          <p className="font-semibold text-[#0F0F0F] mt-0.5 break-all" data-testid="contact-email">{SUPPORT_EMAIL}</p>
        </div>
        <div className="flex gap-3 mt-5">
          <button onClick={copy} className="flex-1 inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#0F0F0F] rounded-full py-3 text-sm font-bold hover:bg-[#c5a030]" data-testid="contact-copy-btn"><Copy size={15} /> Copy Email</button>
          <button onClick={onClose} className="flex-1 inline-flex items-center justify-center bg-[#0F0F0F] text-white rounded-full py-3 text-sm font-bold hover:bg-[#1c1c1c]" data-testid="contact-close-btn">Close</button>
        </div>
        <p className="text-xs text-[#9aa1ab] text-center mt-4">We aim to respond within 1–2 business days.</p>
      </div>
    </div>
  );
};
